import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { investorApi } from "../../api/api";
import { toggleFavorite } from "../../redux/reducers/favoritesSlice";
import CryptoJS from "crypto-js";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import GradientButton from "../common/GradiantButton";
import Loader from "../common/Loader";

const LikedProperties = () => {
  const [allProperties, setAllProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const likedRaw = useSelector(state => state.favorites.items || []);
  const theme = useSelector((data) => data.themeValue.colors);
  const { isAuthenticated , user_refferal_code, userId } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const likedIds = likedRaw.filter(id => typeof id === 'string' && id.includes('_'));
  const uniqueLikedIds = [...new Set(likedIds)];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchProperties = async () => {
      try {
        const response = await investorApi.getPropertiesAndProjects(userId);
        if (response.status === 200 && Array.isArray(response.data)) {
          setAllProperties(response.data);
        } else {
          console.warn("Unexpected API response:", response.data);
        }
      } catch (error) {
        console.error("Error fetching properties:", error);
      }
      finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, [userId]);
  const likedProperties = allProperties.filter((property) => {
    const uniqueId = `${property.type}_${property.id}`;
    return uniqueLikedIds.includes(uniqueId);
  });



  const handleRemoveLike = (property) => {
    const uniqueId = `${property.type}_${property.id}`;
    dispatch(toggleFavorite(uniqueId));
  };

  const generateSlug = (property) => {
        const titlePart = `${property.name}-${property.city}`
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, "")
            .replace(/\s+/g, "-")
            .replace(/-+/g, "-")
            .trim();

        return `${titlePart}-${property.id}`;
    };

    const handleViewDetails = (property) => {
        const slug = generateSlug(property);

        let basePath = "";

        if (property.type === "property") {
            basePath = `/property/${slug}`;
        } else if (property.type === "project") {
            basePath = `/project/${slug}`;
        } else if (property.type === "villa") {
            basePath = `/villa/${slug}`;
        } else if (property.type === "apartment") {
            basePath = `/apartment/${slug}`;
        }

        if (isAuthenticated && user_refferal_code) {
            basePath += `?ref=${user_refferal_code}`;
        }

        window.open(basePath, "_blank");
    };

  // const handleViewDetails = (property) => {

  //   const path = property.type === 'property'
  //     ? `/PropertyDetailsScreen?${property.refferal_code}/${user_refferal_code}`
  //     : property.type === 'project'
  //       ? `/ProjectDetailsScreen?${property.refferal_code}/${user_refferal_code}`
  //       : property.type === 'villa'
  //         ? `/IndividualVillaScreen?${property.refferal_code}/${user_refferal_code}`
  //         : property.type === 'apartment'
  //           ? `/ApartmentPlotsScreen?${property.refferal_code}/${user_refferal_code}` : " ";

  //   navigate(path, {
  //     state: {
  //       propertyId: property.refferal_code,
  //       projectId: property.refferal_code,
  //       villaId: property.refferal_code,
  //       type: property.type
  //     },
  //   });
  // };

  return (
    <Box sx={{ padding: "40px 20px" }}>
      {loading ? (
        <Loader />
      ) : likedProperties.length > 0 ? (
        <>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", mb: 4, color: theme.text }}>
            Your Liked Properties
          </Typography>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "1fr 1fr",
                md: "1fr 1fr 1fr",
              },
              gap: 3,
            }}

          >

            {likedProperties.map((property) => (
              <Card key={`${property.type}_${property.id}`}
                sx={{
                  borderRadius: "16px",
                  cursor: "pointer",
                  backgroundColor: theme.background,
                  overflow: "hidden",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
                  },
                }}
                onClick={() => handleViewDetails(property)}
              >
                <Box
                  component="img"
                  src={property.iconUrl}
                  alt={property.name}
                  sx={{
                    width: "100%",
                    height: 180,
                    objectFit: "cover",

                  }}
                />

                <CardContent>
                  <Typography variant="h6" fontWeight={600} sx={{ color: theme.text }}>
                    {property.name}
                  </Typography>

                  <Typography variant="body2" sx={{ color: theme.text }} gutterBottom>
                    {property.type} • {property.city}
                  </Typography>

                  <Typography variant="body2" sx={{ color: theme.text }}>
                    <strong>Address:</strong> {property.address}
                  </Typography>

                  {/* {property.Numberofplots !== undefined && (
                  <Typography variant="body2" color="text.secondary">
                    <strong>Plots:</strong> {property.Numberofplots}
                  </Typography>
                )} */}

                  <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
                    <GradientButton
                      text="View Details"
                      onClick={() => handleViewDetails(property)}
                      width="50%"
                    >
                      View Details
                    </GradientButton>

                    <Button
                      variant="contained"
                      color="error"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveLike(property);
                      }}
                    >
                      Remove
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        </>
      ) : (
        <Box
          sx={{
            height: "100vh", // Full screen height
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            bgcolor: theme.background
          }}
        >
          <Typography variant="h4" fontWeight={600} gutterBottom color={theme.primary_text_color}>
            No Liked Properties
          </Typography>

          <Typography variant="body1" color={theme.secondary_text_color} mb={4} >
            You haven't liked any properties yet. <br />
            Start browsing to find properties you love!
          </Typography>
          <GradientButton
            text="Browse Properties"
            onClick={() => navigate("/home")}
            width={{ xs: "70%", sm: "40%", md: "40%", lg: '20%' }}
          />

        </Box>
      )}
    </Box>

  );
};

export default LikedProperties;